import React from 'react';

interface SmartdoxxLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  showText?: boolean;
  className?: string;
}

export default function SmartdoxxLogo({ 
  size = 'md', 
  showText = true,
  className = '' 
}: SmartdoxxLogoProps) {
  const sizeClasses = {
    sm: 'h-6 w-auto',
    md: 'h-8 w-auto',
    lg: 'h-10 w-auto',
    xl: 'h-16 w-auto',
    '2xl': 'h-24 w-auto'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-4xl',
    '2xl': 'text-5xl'
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`${sizeClasses[size]} relative`}>
        <img
          src={import.meta.env.VITE_LOGO_URL ?? ''}
          alt="Smartdoxx Logo"
          className={`${sizeClasses[size]} object-contain`}
        />
      </div>
      
      {showText && (
        <span className={`font-semibold text-foreground ${textSizeClasses[size]}`}>
          Smartviewer
        </span>
      )}
    </div>
  );
}
